// The privacy policy (/privacy, Sep 2026): required by Google's OAuth
// consent-screen publishing rules (a homepage URL + privacy policy URL), and
// due on its own account — the pilot stores email addresses and usage events.
// Plain British English, short and true; update it when what we store changes.

export function PrivacyPage() {
  return (
    <div className="content privacy-page">
      <h1>Privacy</h1>
      <p className="muted">Last updated 5 October 2026.</p>

      <h2>What this app stores on your device</h2>
      <p>
        Your tunes, playlists and settings are kept in your browser's local storage. When
        you sign in, they also go to your account, so your other devices have them: saved
        tunes, playlists, how you set each tune up, the tunes you open and how long you play
        them, and the tunes you love or ask to see less of. They stay private unless you
        share a tune or playlist.
      </p>

      <h2>Feedback you send</h2>
      <p>
        A feedback report stores your message, account identity, page, build and browser.
        A tune report also includes the tune's identity and, if you choose a bar, that bar's
        notes and chords. Only you and the app's admin can read your reports. Status updates
        and admin replies are shown on your Feedback page.
      </p>

      <h2>What we store if you sign in</h2>
      <p>
        You need to sign in to open the music. When you do, we store your email address (to sign you in), your
        invite code's group, and — while you are signed in — basic usage events: which tunes
        you load, how long you play along, and which features you use. These exist so your
        teacher can see whether the class is practising, and nothing else.
      </p>

      <h2>What we never do</h2>
      <p>
        No advertising, no trackers, no analytics beyond the events above, and your data is
        never sold or shared with anyone outside the app.
      </p>

      <h2>Services we rely on</h2>
      <p>
        The app is hosted on Cloudflare. Accounts and pilot data are held by Supabase in the
        EU. Sign-in emails are delivered by Resend. If you sign in with Google, Google shares
        only your email address with us.
      </p>

      <h2>Your choices</h2>
      <p>
        You need an account with access during the closed beta. To have your account and its data
        deleted, email <a href="mailto:matthew.c.harrigan@gmail.com">matthew.c.harrigan@gmail.com</a> and
        it will be removed.
      </p>
    </div>
  );
}
